import { imageUrl, srcSet } from '@helpers/image';
import { Device, from } from '@helpers/media';
import SvgArrow from '@img/icons/accordion-arrow.svg';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import * as React from 'react';
import S from './SectionItem.styles';
const SectionItem = ({ accentColor, active, content, cta, duration: autoplayDuration, icon, image, paused, title, onClick, }) => {
    return (React.createElement(S.Container, { "aria-current": active, initial: active ? 'opened' : 'closed', animate: active ? 'opened' : 'closed', style: { '--accentColor': accentColor } },
        React.createElement(S.Header, { onClick: (event) => {
                event.preventDefault();
                onClick();
            } },
            React.createElement(S.Icon, { alt: icon.altText, loading: "lazy", src: imageUrl(icon, { width: 154, height: 154, rmode: 'pad' }) }),
            React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title),
            React.createElement(S.Progress, null,
                React.createElement(S.ProgressInner, { initial: 'closed', animate: active ? 'opened' : 'closed', variants: {
                        closed: {
                            scaleX: 0,
                            transition: {
                                duration: 0.3,
                                ease: 'easeOut',
                            },
                        },
                        opened: {
                            scaleX: 1,
                            transition: {
                                duration: paused ? 0.3 : autoplayDuration / 1000,
                                ease: paused ? 'easeOut' : 'linear',
                            },
                        },
                    } })),
            React.createElement(S.ArrowWrapper, { variants: {
                    closed: {
                        rotate: 180,
                    },
                    opened: {
                        rotate: 0,
                    },
                } },
                React.createElement(SvgArrow, null))),
        React.createElement(S.Body, { variants: {
                closed: {
                    height: 0,
                },
                opened: {
                    height: 'auto',
                },
            }, transition: {
                duration: 0.3,
                ease: 'easeOut',
            } },
            React.createElement(S.ImageWrapper, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.Tablet), srcSet: srcSet(image, { width: 987, height: 441 }) }),
                    React.createElement("source", { media: from(Device.MobileLarge), srcSet: srcSet(image, { width: 731, height: 327 }) }),
                    React.createElement("source", { media: from(Device.Mobile), srcSet: srcSet(image, { width: 443, height: 198 }) }),
                    React.createElement(S.Image, { alt: image.altText, loading: "lazy", src: imageUrl(image, { width: 339, height: 151 }), srcSet: srcSet(image, { width: 339, height: 151 }) }))),
            React.createElement(S.Content, null, content),
            cta && (React.createElement(S.CtaWrapper, null,
                React.createElement(LinkButton, { buttonType: "default", href: cta.url, target: cta.target }, cta.text))))));
};
export default SectionItem;
